import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ac816ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("audio", {
    src: _ctx.attachImageUrl(_ctx.songUrl),
    preload: "true",
    ref: _ctx.player,
    onCanplay: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.canplay && _ctx.canplay(...args))),
    onTimeupdate: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.timeupdate && _ctx.timeupdate(...args))),
    onEnded: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ended && _ctx.ended(...args)))
  }, null, 40, _hoisted_1))
}